import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { NgMediaPlayerService } from '../../shared/media-player/ng-media-player.service';
import { StudyBundleCourseDto } from '../../shared/types/StudyBundleCourseDto';

@Component({
  selector: 'lp2-news-tile',
  templateUrl: './news-tile.component.html',
  styleUrls: ['./news-tile.component.scss'],
})
export class NewsTileComponent implements OnDestroy {
  @Input()
  news: StudyBundleCourseDto = <StudyBundleCourseDto>{};

  @Output()
  closePlayer = new EventEmitter<number>();

  playerClosedSubscription: Subscription;

  constructor(private mediaPlayerService: NgMediaPlayerService) {}

  getNewsTileId(): string {
    return 'news-' + this.news.id;
  }

  playNews() {
    this.mediaPlayerService.playMedia(this.news, true);

    this.playerClosedSubscription = this.mediaPlayerService.playerClosed.subscribe(
      () => {
        this.playerClosedSubscription.unsubscribe();
        this.closeNews();
      }
    );
  }

  ngOnDestroy() {
    if (this.playerClosedSubscription) {
      this.playerClosedSubscription.unsubscribe();
    }
  }

  closeNews() {
    this.closePlayer.emit(this.news.id);
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/news-tile/news-tile.component.ts